fragment FullWidthTeaserFragment on fullWidthTeaser_Entry {
  typeHandle

  # Content
  mainHeading
  heading
  teaser
  imageOrVideo {
    ...CraftAssetFragment
  }
  tag
  cta {
    ...LinkFragment

    # if the link is to a product, get the section and shopify handles
    ... on HyperLinkInterface {
      element {
        ... on products_Entry {
          sectionHandle
          shopifyHandle
        }
      }
    }
  }
  secondaryCta {
    ...LinkFragment
  }

  # Layout
  fullWidthTeaserLayout
  headingSize
  buttonPrimary
  editorsPick
  boxPosition
  position
  hasScrollingContent
  boxOutside
}
